module.exports = __webpack_public_path__ + "img/soloviev.03b735ed.jpg";